export const import_theme_atom_to_client_service = {
  error_unknown: 'Something is wrong, an unexpected error has occurred.',
  import_error: 'Import failed',
  import_success: 'Import successful',
  importing: 'Importing',
} as const;
